export function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

export const getSearchMatch = (str: string, searchQuery:string) => str.match(RegExp(`(.*)(${escapeRegExp(searchQuery)})(.*)`, 'i'));
